import { z } from "zod";

import { UserEntity } from "../../../model";

import { UserRoleEntity } from "~/entities/user-role/@x/user";
import { Response } from "~/shared/api";

const zSchema = UserEntity.zSchema;

const zOutSchema = UserEntity.zSchema
  .pick({
    id: true,
  })
  .extend({
    email: zSchema.shape.email.nullable(),
    phoneNumber: zSchema.shape.phone.nullable(),
    userName: zSchema.shape.username.nullable(),
    firstName: zSchema.shape.firstName.nullable(),
    lastName: zSchema.shape.lastName.nullable(),
    roles: z.array(
      UserRoleEntity.zSchema.extend({
        name: UserRoleEntity.zSchema.shape.name.nullable(),
        description: UserRoleEntity.zSchema.shape.description.nullable(),
      }),
    ),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zRes401 = Response.Schema.zUnsuccessful(401);

export { zOutSchema, zRes401 };
export type { OutSchema };
